import type { SelectOption } from '../../../ui/select_field/types';

export const AMAZON_TRANSCRIBE_LANGUAGES: SelectOption[] = [
  //cspell:disable-next-line
  { value: 'ab-GE', label: 'Abkhaz' },
  { value: 'af-ZA', label: 'Afrikaans' },
  { value: 'ar-AE', label: 'Arabic, Gulf' },
  { value: 'ar-SA', label: 'Arabic, Modern Standard' },
  { value: 'hy-AM', label: 'Armenian' },
  //cspell:disable-next-line
  { value: 'ast-ES', label: 'Asturian' },
  { value: 'az-AZ', label: 'Azerbaijani' },
  { value: 'ba-RU', label: 'Bashkir' },
  { value: 'eu-ES', label: 'Basque' },
  { value: 'be-BY', label: 'Belarusian' },
  { value: 'bn-IN', label: 'Bengali' },
  { value: 'bs-BA', label: 'Bosnian' },
  { value: 'bg-BG', label: 'Bulgarian' },
  { value: 'ca-ES', label: 'Catalan' },
  { value: 'ckb-IR', label: 'Central Kurdish, Iran' },
  { value: 'ckb-IQ', label: 'Central Kurdish, Iraq' },
  { value: 'zh-HK', label: 'Chinese, Cantonese' },
  { value: 'zh-CN', label: 'Chinese, Simplified' },
  { value: 'zh-TW', label: 'Chinese, Traditional' },
  { value: 'hr-HR', label: 'Croatian' },
  { value: 'cs-CZ', label: 'Czech' },
  { value: 'da-DK', label: 'Danish' },
  { value: 'nl-NL', label: 'Dutch' },
  { value: 'en-AU', label: 'English, Australian' },
  { value: 'en-GB', label: 'English, British' },
  { value: 'en-IN', label: 'English, Indian' },
  { value: 'en-IE', label: 'English, Irish' },
  { value: 'en-NZ', label: 'English, New Zealand' },
  { value: 'en-AB', label: 'English, Scottish' },
  { value: 'en-ZA', label: 'English, South African' },
  { value: 'en-US', label: 'English, US' },
  { value: 'en-WL', label: 'English, Welsh' },
  { value: 'et-EE', label: 'Estonian' },
  { value: 'fa-IR', label: 'Farsi' },
  { value: 'fi-FI', label: 'Finnish' },
  { value: 'fr-FR', label: 'French' },
  { value: 'fr-CA', label: 'French, Canadian' },
  { value: 'gl-ES', label: 'Galician' },
  { value: 'ka-GE', label: 'Georgian' },
  { value: 'de-DE', label: 'German' },
  { value: 'de-CH', label: 'German, Swiss' },
  { value: 'el-GR', label: 'Greek' },
  { value: 'gu-IN', label: 'Gujarati' },
  { value: 'ha-NG', label: 'Hausa' },
  { value: 'he-IL', label: 'Hebrew' },
  { value: 'hi-IN', label: 'Hindi, Indian' },
  { value: 'hu-HU', label: 'Hungarian' },
  { value: 'is-IS', label: 'Icelandic' },
  { value: 'id-ID', label: 'Indonesian' },
  { value: 'it-IT', label: 'Italian' },
  { value: 'ja-JP', label: 'Japanese' },
  { value: 'kab-DZ', label: 'Kabyle' },
  { value: 'kn-IN', label: 'Kannada' },
  { value: 'kk-KZ', label: 'Kazakh' },
  //cspell:disable-next-line
  { value: 'rw-RW', label: 'Kinyarwanda' },
  { value: 'ko-KR', label: 'Korean' },
  { value: 'ky-KG', label: 'Kyrgyz' },
  { value: 'lv-LV', label: 'Latvian' },
  { value: 'lt-LT', label: 'Lithuanian' },
  { value: 'lg-IN', label: 'Luganda' },
  { value: 'mk-MK', label: 'Macedonian' },
  { value: 'ms-MY', label: 'Malay' },
  { value: 'ml-IN', label: 'Malayalam' },
  { value: 'mt-MT', label: 'Maltese' },
  { value: 'mr-IN', label: 'Marathi' },
  { value: 'mhr-RU', label: 'Meadow Mari' },
  { value: 'mn-MN', label: 'Mongolian' },
  //cspell:disable-next-line
  { value: 'no-NO', label: 'Norwegian Bokmål' },
  //cspell:disable-next-line
  { value: 'or-IN', label: 'Odia/Oriya' },
  { value: 'ps-AF', label: 'Pashto' },
  { value: 'pl-PL', label: 'Polish' },
  { value: 'pt-PT', label: 'Portuguese' },
  { value: 'pt-BR', label: 'Portuguese, Brazilian' },
  { value: 'pa-IN', label: 'Punjabi' },
  { value: 'ro-RO', label: 'Romanian' },
  { value: 'ru-RU', label: 'Russian' },
  { value: 'sr-RS', label: 'Serbian' },
  //cspell:disable-next-line
  { value: 'si-LK', label: 'Sinhala' },
  { value: 'sk-SK', label: 'Slovak' },
  { value: 'sl-SI', label: 'Slovenian' },
  { value: 'so-SO', label: 'Somali' },
  { value: 'es-ES', label: 'Spanish' },
  { value: 'es-US', label: 'Spanish, US' },
  { value: 'su-ID', label: 'Sundanese' },
  { value: 'sw-BI', label: 'Swahili, Burundi' },
  { value: 'sw-KE', label: 'Swahili, Kenya' },
  { value: 'sw-RW', label: 'Swahili, Rwanda' },
  { value: 'sw-TZ', label: 'Swahili, Tanzania' },
  { value: 'sw-UG', label: 'Swahili, Uganda' },
  { value: 'sv-SE', label: 'Swedish' },
  { value: 'tl-PH', label: 'Tagalog/Filipino' },
  { value: 'ta-IN', label: 'Tamil' },
  { value: 'tt-RU', label: 'Tatar' },
  { value: 'te-IN', label: 'Telugu' },
  { value: 'th-TH', label: 'Thai' },
  { value: 'tr-TR', label: 'Turkish' },
  { value: 'uk-UA', label: 'Ukrainian' },
  //cspell:disable-next-line
  { value: 'ug-CN', label: 'Uyghur' },
  { value: 'uz-UZ', label: 'Uzbek' },
  { value: 'vi-VN', label: 'Vietnamese' },
  { value: 'cy-WL', label: 'Welsh' },
  { value: 'wo-SN', label: 'Wolof' },
  { value: 'zu-ZA', label: 'Zulu' },
];
